module.exports = __webpack_public_path__ + "fonts/ClashDisplay-Variable.27b50dc.woff2";